<div nz-row nzGutter="0" style="padding-top:24px;padding-right:24px">
  <div nz-col nzSpan="4" style="text-align: center;"> </div>
  <div nz-col nzSpan="24">
    <nz-form-item>
      <nz-form-label #label nzFor="typeOfPersonnel"><b>Loại nhân sự</b></nz-form-label>
      <nz-form-control nzErrorTip="Nhập trường thông tin bắt buộc">
        <nz-radio-group [(ngModel)]="typeOfPersonnel" nzButtonStyle="solid" (ngModelChange)="onChangeStatus($event)">
          <ng-container *ngFor="let item of typeOfPersonnels">
            <label nz-radio [nzValue]="item.id">{{item.typeOfPersonnelName}}</label>
          </ng-container>
        </nz-radio-group>
      </nz-form-control>
    </nz-form-item>
  </div>
  <div nz-col nzSpan="4" style="text-align: center;"> </div>
  <div nz-col nzSpan="24">
    <ng-container *ngIf="formType === 1">
      <app-can-bo-quan-ly [EducationAndTrainingOrSchoolId]="EducationAndTrainingOrSchoolId"
        [typeOfPersonnel]="typeOfPersonnel" [formType]="formType">
      </app-can-bo-quan-ly>
    </ng-container>
    <ng-container *ngIf="formType !== 1">
      <app-giao-vien-nhan-vien [EducationAndTrainingOrSchoolId]="EducationAndTrainingOrSchoolId"
        [typeOfPersonnel]="typeOfPersonnel" [formType]="formType">
      </app-giao-vien-nhan-vien>
    </ng-container>
  </div>
</div>
